import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { MODULE_NAME as PERFORMANCE_RULES_MODULE } from 'modules/performance-rules/config/routes';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FILTER_TYPE } from '../../filters';
import columnDefinitions from './columnDefinitions';
import { PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID } from './preformanceRuleActionsReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const performanceRuleExecutedActionsReportConfig = {
    id: PERFORMANCE_RULE_EXECUTED_ACTIONS_REPORT_ID,
    label: 'Rule Actions',
    accountConfigurations: {
        [FEATURE_FLAGS.PERFORMANCE_RULES_EXECUTED_ACTIONS_ENABLED]: 'true',
    },
    module: PERFORMANCE_RULES_MODULE,
    endpoint: 'performance-rule-executed-actions',
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    searchPlaceholderMsgId: 'performance.rules.report.search.placeholder',
    searchField: 'rule_name_search',
    filters: [
        {
            id: FILTER_TYPE.CAMPAIGN_NAME,
        },
        {
            id: FILTER_TYPE.RULE_NAME,
        },
    ],
    initialFilters: [],
};
